export const CreatorRemarksSection = ({ oyeCreatorRemark }) => {
  return (
    <div>
      <h4 className="font-medium text-gray-900 mb-2">Oye Creators Remarks</h4>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p className="text-blue-800">{oyeCreatorRemark}</p>
      </div>
    </div>
  )
}
